export const wrapper = {
	display: 'flex',
	width: {
		// applies different widths based on screen size
		xs: '87%',
		md: 'unset',
	},
};

export const colorBlock = (bgColor: string) => ({
	height: '10px',
	backgroundColor: bgColor,
	margin: '1rem 0',
	width: {
		md: '83.4px', // applies width only on md and up
	},
	flex: {
		xs: 1,
		md: 'unset', // removes flex on md and up
	},
});
